// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root[data-v-1ead08a1] {\n  width: 100%;\n  height: 100%;\n  background-color: #fff;\n  display: block;\n}\n.canvasPanel[data-v-1ead08a1] {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  float: left;\n  width: 70%;\n  background-color: #fff;\n  border-bottom: 1px solid #E9E9E9;\n}", ""]);
// Exports
module.exports = exports;
